"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const server_1 = require("@kalkulacka-one/design-system/server");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const react_1 = require("@headlessui/react");
const js_1 = require("@mdi/js");
const React = __importStar(require("react"));
const icon_1 = require("./icon");
function ExpandableCardComponent(props, ref) {
    const { className, ...rest } = props;
    const cardProps = {
        ...rest,
        interactive: true,
        className: (0, utilities_1.twMerge)("ko:grid ko:grid-flow-row", className),
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Disclosure, { ...cardProps, as: server_1.Card, ref: ref, children: (renderProps) => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: typeof props.children === "function" ? props.children(renderProps) : props.children }) }));
}
function ExpandableCardContent({ children, className }) {
    return (0, jsx_runtime_1.jsx)(react_1.DisclosureButton, { className: className, children: children });
}
function ExpandableCardHiddenContent({ children, className }) {
    return (0, jsx_runtime_1.jsx)(react_1.DisclosurePanel, { className: (0, utilities_1.twMerge)("ko:overflow-hidden", className), children: children });
}
function ExpandableCardChevron({ className, open = false }) {
    return (0, jsx_runtime_1.jsx)(icon_1.Icon, { icon: js_1.mdiChevronDown, className: (0, utilities_1.twMerge)(open ? "ko:rotate-180" : "", className), size: "medium", decorative: true });
}
exports.ExpandableCard = Object.assign(React.forwardRef(ExpandableCardComponent), {
    Content: ExpandableCardContent,
    HiddenContent: ExpandableCardHiddenContent,
    Chevron: ExpandableCardChevron,
});
